import { ColorLabelProviderAbstract } from './colorlabelprovider.service.abstract';

export class ColorLabelProviderServiceProfit extends ColorLabelProviderAbstract {

  public label(benefit: number, cost: number, invest: number) {
    return this.translate('RADIAL.DEFAULT.DISPLAY.LABEL.TOP.PROFIT') + ': ' + (benefit - cost - invest);
  }

}
